import { useState, useEffect, useCallback } from 'react';

export interface SocialLink {
  label: string;
  icon: string;
  url: string;
}

export interface SiteConfig {
  contactEmail: string;
  icpNumber: string;
  copyrightText: string;
  socialLinks: SocialLink[];
}

const FALLBACK_CONFIG: SiteConfig = {
  contactEmail: 'txby666666@163.com',
  icpNumber: '江-1234567890-25',
  copyrightText: '天天漫画 版权所有 2026 All Rights Reserved',
  socialLinks: [
    { label: '微博', icon: 'ri-weibo-line', url: '#' },
    { label: '微信', icon: 'ri-wechat-line', url: '#' },
    { label: 'QQ', icon: 'ri-qq-line', url: '#' },
  ],
};

function resolveJsonUrl(): string {
  const base =
    typeof __BASE_PATH__ === 'string' && __BASE_PATH__ !== '/' && __BASE_PATH__ !== ''
      ? __BASE_PATH__.replace(/\/+$/, '')
      : '';
  return `${base}/site-config.json`;
}

export function useSiteConfig() {
  const [config, setConfig] = useState<SiteConfig>(FALLBACK_CONFIG);

  const load = useCallback(() => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 3000);

    fetch(resolveJsonUrl(), { signal: controller.signal })
      .then((res) => {
        if (!res.ok) throw new Error('加载站点配置失败');
        return res.json();
      })
      .then((data: SiteConfig) => {
        setConfig({ ...FALLBACK_CONFIG, ...data });
      })
      .catch(() => {
        setConfig(FALLBACK_CONFIG);
      })
      .finally(() => {
        clearTimeout(timeout);
      });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { config, reload: load };
}